import type { ComponentType } from 'react';
import { isPostOwnedByUser } from '@wlb/shared/utils/postOwnership';
import type { Profile } from '@wlb/shared/types';
import type { FeedPost } from '@wlb/shared/types/post';
import type { IconProps } from '../../components/ui/icons';
import {
  AlertCircleIcon,
  BookmarkIcon,
  CreateIcon,
  LockIcon,
  MessagesIcon,
  TrashIcon,
  UserIcon,
} from '../../components/ui/icons';

export type PostOptionKey = 'save' | 'message' | 'profile' | 'report' | 'block' | 'edit' | 'delete';

export interface PostOptionItem {
  key: PostOptionKey;
  label: string;
  icon: ComponentType<IconProps>;
  destructive?: boolean;
}

export const buildPostOptions = (
  post: FeedPost,
  profile: Profile | null,
  t: (key: string, values?: Record<string, string | number>) => string,
): PostOptionItem[] => {
  const isOwned = isPostOwnedByUser(post, profile);
  const saveLabel = post.saved ? t('home.postOptions.unSave') : t('home.postOptions.save');

  if (isOwned) {
    return [
      { key: 'edit', icon: CreateIcon, label: t('home.postOptions.editPost') },
      { key: 'delete', icon: TrashIcon, label: t('home.postOptions.deletePost'), destructive: true },
      { key: 'save', icon: BookmarkIcon, label: saveLabel },
    ];
  }

  return [
    { key: 'save', icon: BookmarkIcon, label: saveLabel },
    { key: 'message', icon: MessagesIcon, label: t('home.postOptions.message', { username: post.username }) },
    { key: 'profile', icon: UserIcon, label: t('home.postOptions.profile') },
    { key: 'report', icon: AlertCircleIcon, label: t('home.postOptions.report') },
    {
      key: 'block',
      icon: LockIcon,
      label: post.isBlocked ? t('home.postOptions.unblockUser') : t('home.postOptions.blockUser'),
    },
  ];
};